module.exports = __webpack_public_path__ + "static/img/dorm-active.bb7caa6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/menu/dorm-active.png
// module id = ePod
// module chunks = 58